module.exports = __webpack_public_path__ + "static/media/production-network-01.21c71a5f.jpg";